document.addEventListener('DOMContentLoaded', function () {
  const insurePrdForm = document.querySelector(".insurance_prd_frm [data-insurance-prdvr-id]");
  const insuranceVariantId = insurePrdForm ? Number(insurePrdForm?.value) : Number(document.body.dataset.instantPrdId);

  async function addInsuranceToCart() {
    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      const insuranceItem = cart.items.find(item => item.variant_id == insuranceVariantId);

      if (!insuranceItem) {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: insuranceVariantId,
              quantity: 1
            }]
          })
        });

        const data = await response.json();

        if (data) {
          document.querySelector("input[name='insure_prd_input']")?.setAttribute('line_item_key', data?.items[0]?.key);
        }
      } else {
        console.log('Insurance already added to the cart');
      }
    } catch (error) {
      console.error('Error adding insurance:', error);
    }
  }

  const updateItem = async (data) => {
    try {
      const req = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });

      if (!req.ok) {
        throw new Error('Failed to update cart');
      }
      document.querySelector('[line_item_key]')?.removeAttribute('line_item_key');
    } catch (error) {
      console.error('Error updating item:', error);
    }
  };

  const updateCart = async () => {
    if (document.querySelector(".cart.template-cart")) return;

    try {
      const response = await fetch('/cart?view=ajax_side_cart', {
        method: 'GET',
        cache: 'no-cache'
      });

      const data = await response.text();
      const cartHTML = document.createElement('div');
      cartHTML.innerHTML = data;

      const cartTotalPrice = cartHTML.querySelector(".previewCartTotalsPrice")?.innerHTML;
      if (cartTotalPrice) {
        document.querySelector(".previewCartTotalsPrice").innerHTML = cartTotalPrice;
        const total = cartHTML.querySelector('[data-cart-total-value]').getAttribute('data-cart-total-value');
        const width = (total / (free_shipping_price * 100)) * 100;
        const message = width < 100 ? `<span>Only </span>${Shopify.formatMoney((((free_shipping_price * 100) - total)), window.money_format)}<span> away from </span><span class="text">free shipping</span>` : `<span>You qualify for free shipping!</span>`

        document.querySelector('.progress-meter').style.width = `${width >= 100 ? 100 : width}%`;
        document.querySelector('.message[data-shipping-message]').innerHTML = message;
      }
      else if (cartHTML.querySelector(".previewCart")) {
        document.querySelector('.previewCart').innerHTML = cartHTML.querySelector(".previewCart").innerHTML;
        document.querySelector('.previewCartTool')?.remove();
        document.querySelector('.popup-toolDowns')?.remove();
        document.querySelector('.previewCartInfo')?.remove();
        document.querySelector('[data-shipping-progress]')?.classList.add('progress-hidden', 'none');
        document.querySelector('.message[data-shipping-message]').innerHTML = `Free shipping for all orders over ${Shopify.formatMoney((free_shipping_price * 100), window.money_format)}!`;
      }
    } catch (error) {
      console.error('Error updating item:', error);
    }
  };

  const updateMainCart = async (cart) => {
    try {
      const sectionId = document.querySelector('#main-cart-items').getAttribute('data-id');

      const cartElement = document.querySelector('[data-cart]');
      const cartContent = cartElement.querySelector('[data-cart-content]');
      const cartTotals = cartElement.querySelector('[data-cart-total]');

      const cartLoading = `
      <div class="loading-overlay loading-overlay--custom">
        <div class="loading-overlay__spinner">
          <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
          </svg>
        </div>
      </div>`;

      const loadingClass = 'is-loading';

      cartElement.classList.add(loadingClass);
      cartElement.insertAdjacentHTML('afterbegin', cartLoading);

      const response = await fetch(`/cart?section_id=${sectionId}`);
      const data = await response.text();

      const jsPreventedData = data.replaceAll('cart-coupon-discount', 'div');
      const parsedResponse = new DOMParser().parseFromString(jsPreventedData, 'text/html');

      cartElement.classList.remove(loadingClass);
      cartElement.querySelector('.loading-overlay').remove();

      if (cart.item_count > 0) {
        const contentCart = parsedResponse.querySelector('[data-cart-content] .cart').innerHTML;
        const subTotal = parsedResponse.querySelector('[data-cart-total] .cart-total-subtotal').innerHTML;
        const grandTotal = parsedResponse.querySelector('[data-cart-total] .cart-total-grandtotal').innerHTML;
        const savings = parsedResponse.querySelector('[data-cart-total] .cart-total-savings').innerHTML;

        cartContent.querySelector('.cart').innerHTML = contentCart;
        cartTotals.querySelector('.cart-total-subtotal').innerHTML = subTotal;
        cartTotals.querySelector('.cart-total-grandtotal').innerHTML = grandTotal;
        cartTotals.querySelector('.cart-total-savings').innerHTML = savings;

        const calculatorShipping = parsedResponse.querySelector('.haloCalculatorShipping');
        if (calculatorShipping) {
          const existingCalculator = cartElement.querySelector('.haloCalculatorShipping');
          if (existingCalculator) {
            existingCalculator.replaceWith(calculatorShipping);
          }
        }

        document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));

        document.querySelectorAll('[data-free-shipping-wrapper]').forEach(freeShippingWrapper => {
          const changeEvent = new Event('change', { bubbles: true })
          freeShippingWrapper.dispatchEvent(changeEvent);
        })
      } else {
        const contentCart = parsedResponse.querySelector('#main-cart-items').innerHTML;
        const headerCart = parsedResponse.querySelector('.page-header').innerHTML;

        document.querySelector('#main-cart-items').innerHTML = contentCart;
        document.querySelector('.page-header').innerHTML = headerCart;

        document.querySelectorAll('[data-free-shipping-wrapper]').forEach(freeShippingWrapper => {
          const changeEvent = new Event('change', { bubbles: true })
          freeShippingWrapper.dispatchEvent(changeEvent);
        })
      }
    } catch (error) {
      console.error('Error updating cart:', error);
    }
  };

  function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  function getInsureIsAdded() {
    if (sessionStorage.getItem('insure_prd_input_checked') !== null) {
      return sessionStorage.getItem('insure_prd_input_checked') ;
    }
  }

  async function handleInsProductInput() {
    const IsProductAdded = document.querySelector('[line_item_key]') ? true : false;
    if (IsProductAdded) {
      const id = document.querySelector('[line_item_key]')?.getAttribute('line_item_key');
      const quantity = 0;
      const data = { id, quantity };
      await updateItem(data);
      await updateCart()
    }
    else {
      const totalQty = document.querySelector('[data-cart-count]').innerText;
      if (totalQty > 0) {
        await addInsuranceToCart();
        await updateCart();
      }
    }
  }

  document.addEventListener("click", async function (event) {
    if (event.target.closest(".insure_prd_slider") && !document.querySelector(".cart.template-cart")) {
      await handleInsProductInput();
    }

    if (event.target.closest(".insure_prd_slider")) { 
      const insurePrdInput = document.querySelector('input[name="insure_prd_input"]'); 
      sessionStorage.setItem('insure_prd_input_checked', insurePrdInput?.checked);
      console.log(" getInsureIsAdded()",  getInsureIsAdded());     
    }

    // if (event.target.closest("[data-btn-addtocart]")) {
    //   addInsuranceToCart();
    // }
  });

  if (document.querySelector(".cart.template-cart")) {
    document.addEventListener("click", async function (event) {
      if (event.target.closest(".insure_prd_slider")) {
        await handleInsProductInput();
        Shopify.getCart(async (cart) => {
          await updateMainCart(cart); 
        });
      }
    });
  }

  window.addEventListener("insure-start-add",async  function () {
    // setTimeout(async () => {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      const insuranceItem = cart.items.find(item => item.variant_id == insuranceVariantId);
      // const getInputCheked = getInsureIsAdded();

      if (window.insuranceStepSecondAdded && window.insuranceStepOneAdded && !insuranceItem) {
        // if () {
            document.querySelector('.insure_prd_slider')?.click();  
        // } 
      }


      console.log("global event fires");

    // }, 2500);
    
  });

});


